module.exports = __webpack_public_path__ + "img/icon-14.76201d8f.png";